module.exports = __webpack_public_path__ + "static/media/riel.214217fc.svg";